import { ipsos, supuesto } from ".";

// Lámina 104 (viajes laborales, base 400/124). La pestaña Personales reusa
// src/data/ipsos2025/vacaciones.js (IPSOS_VACACIONES/TEMPORADA_OPCIONES/TICKETS_VACACIONES,
// lámina 100) — mismos datos, una sola copia (10.1).
const P_VIAJAN = "¿Viaja por trabajo?";
const P_FRECUENCIA = "¿Con qué frecuencia viaja por trabajo?";
const P_DECISOR = "¿Quién decide la compra del viaje?";
const P_HOSPEDAJE = "¿Dónde se hospeda en sus viajes de trabajo?";

export const IPSOS_LABORALES = {
  viajan: ipsos(0.3, { lamina: 104, pregunta: P_VIAJAN, base: 400 }),

  // viajesMes = supuesto comercial derivado de la etiqueta de frecuencia Ipsos
  frecuencia: {
    semanal: {
      pct: ipsos(0.174, { lamina: 104, pregunta: P_FRECUENCIA, base: 124 }),
      viajesMes: supuesto(4, { nota: "viajes/mes" }),
      label: "Semanalmente",
    },
    mensual: {
      pct: ipsos(0.409, { lamina: 104, pregunta: P_FRECUENCIA, base: 124 }),
      viajesMes: supuesto(1, { nota: "viajes/mes" }),
      label: "Mensualmente",
    },
    trimestral: {
      pct: ipsos(0.243, { lamina: 104, pregunta: P_FRECUENCIA, base: 124 }),
      viajesMes: supuesto(0.33, { nota: "viajes/mes" }),
      label: "Trimestralmente",
    },
    semestral: {
      pct: ipsos(0.103, { lamina: 104, pregunta: P_FRECUENCIA, base: 124 }),
      viajesMes: supuesto(0.17, { nota: "viajes/mes" }),
      label: "Semestralmente",
    },
    anual: {
      pct: ipsos(0.071, { lamina: 104, pregunta: P_FRECUENCIA, base: 124 }),
      viajesMes: supuesto(0.083, { nota: "viajes/mes" }),
      label: "Anualmente",
    },
  },

  decisorCompra: {
    "La empresa": ipsos(0.503, { lamina: 104, pregunta: P_DECISOR, base: 124 }),
    "El viajero": ipsos(0.375, { lamina: 104, pregunta: P_DECISOR, base: 124 }),
    "El jefe": ipsos(0.082, { lamina: 104, pregunta: P_DECISOR, base: 124 }),
    Agencia: ipsos(0.039, { lamina: 104, pregunta: P_DECISOR, base: 124 }),
  },

  hospedaje: {
    Hotel: ipsos(0.788, { lamina: 104, pregunta: P_HOSPEDAJE, base: 124 }),
    Airbnb: ipsos(0.111, { lamina: 104, pregunta: P_HOSPEDAJE, base: 124 }),
    "Casa empresa": ipsos(0.043, { lamina: 104, pregunta: P_HOSPEDAJE, base: 124 }),
    Casa: ipsos(0.03, { lamina: 104, pregunta: P_HOSPEDAJE, base: 124 }),
    Hostal: ipsos(0.028, { lamina: 104, pregunta: P_HOSPEDAJE, base: 124 }),
  },
};

// Supuestos comerciales (CLP)
export const TICKETS_LABORALES = [
  supuesto(80000, { nota: "ticket promedio pasaje" }),
  supuesto(150000, { nota: "ticket promedio pasaje" }),
  supuesto(300000, { nota: "ticket promedio pasaje" }),
  supuesto(600000, { nota: "ticket promedio pasaje" }),
];

// Hospedaje estimado como % adicional sobre el pasaje
export const FACTOR_HOSPEDAJE = supuesto(0.6, { nota: "hospedaje estimado, % del pasaje" });
